<template>
    <div class="content-wrapper">
        <!--Хлебные крошки-->
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <!---->
        <VideoHelper @set-visible="setVideoHelepVisible" v-if="showVideoHelp && !isVideoHintHidden" video-id="uZGzWaDYpdYxhRz9D9qJhU"/>
        <v-dialog v-if="showVideoHelpStories" v-model="showVideoHelpStories">
            <VideoHelper class='sightseeing-tour' :isSized="true" @set-visible="setVideoHelepStoriesVisible" video-id="tsTgay3w3ddLh6HHkc5xFp"/>
        </v-dialog>        
        <DeleteConnectorConfirm v-model="deleteConectorConfirmIsOpen"
        :connectors="connectorsForDelete"
        ></DeleteConnectorConfirm>
            <div class="content project-page-content">
            <!--Диалоговые окна-->

            <v-dialog v-model="isAddUserDialog" width="500">
                <AddUserDialog :projectId="project.id"> </AddUserDialog>
            </v-dialog>
            <RenameUserDialog></RenameUserDialog>
            <div class="project-hero">
                <div class="overlay" :style="overlayStyle"></div>
                <div class="project-title-wrapper">
                    <h1 class="font-weight-medium project-title">{{ project.name }}</h1>
                    <RenameProjectBtn
                        :projectId="project.id"
                        v-if="projectStatus === 'open' && checkRole(project.id, 'project:rename')"
                    ></RenameProjectBtn>
                    <ProjectSettingsBtn
                        v-if="projectStatus === 'open' && checkRole(project.id, 'project:settings:view')"
                    ></ProjectSettingsBtn>
                    <ProjectHeaderHintBtn hintId="project"></ProjectHeaderHintBtn>
                </div>
                <Stories @show-video="setVideoHelepStoriesVisible" :style="{ marginTop: '5px' }" />
            </div>

            <div
                class="project-lock-scope"
                :class="{ 'project-lock-scope--blocked': showLocalBillingLock }"
            >
                <div class="project-lock-scope__content">
                    <div class="mt-11">
                        <div class="btns-block ma-0">
                            <div class="section-head">
                                <h2 v-once class="section-title">Виджеты</h2>
                                <HintIcon v-once hintId="widgets" :size="17"></HintIcon>
                            </div>
                            <StarterPackPromoCard
                                v-if="showStarterPackPromo"
                                :to="starterPackUrl"
                                :trial-days-left="trialDaysLeft"
                                :scenario-total="starterPackScenarioTotal"
                                :scenario-active="starterPackScenarioActive"
                                :scenarios-loading="starterPackScenariosLoading"
                            />
                        </div>
                    </div>
                    <CardsViewDashboards
                        :dashBoards="dashBoards"
                        :projectId="project.id"
                        :projectStatus="projectStatus"
                    />
                    <div class="mt-14">
                        <UserList :selectedUsers="selectedUsers" @edit-users="editUsersFromChild"/>
                    </div>
                </div>
                <div
                    v-if="showLocalBillingLock"
                    class="project-lock-scope__blur"
                    aria-hidden="true"
                />
                <DemoSubView
                    v-if="showLocalBillingLock"
                    overlay
                />
            </div>

            <div class="mt-14" id="channels-section">
                <div id="scheduled-report-section">
                    <ScheduledReportSection
                        v-if="projectStatus === 'open' && checkRole(project.id, 'project:scheduledReport:view')"
                    />
                </div>
                <!-- Каналы и Источники -->
                <!-- Новая логика с табами и неактивными карточками -->
                <ChannelsTabs
                    v-if="project.isChannelsRework && checkRole(project.id, 'project:connector:view') && !isBeautyAutopilotOnly"
                    :project="project"
                    :channels="channels"
                    :connectors="connectors"
                    :allChannelsCards="allChannelsCards"
                    :telephonyConnectors="telephonyConnectors"
                    :allTelephonyCards="allTelephonyCards"
                    :allSourcesCards="allSourcesCards"
                    :selectedConnectors="selectedConnectors"
                    @update:selectedConnectors="selectedConnectors = $event"
                    @add-connector="addConector"
                    @openConnectorSettings="openConnectorSettings"
                    @openConnectorSettingsInSidebar="openConnectorSettingsInSidebar"
                    @deleteConnector="deleteConnector"
                />
                <!-- Старая логика - все источники в одном месте -->
                <div v-else-if="!project.isChannelsRework && checkRole(project.id, 'project:connector:view') && !isBeautyAutopilotOnly" class="mt-14">
                    <div class="btns-block ma-0">
                        <v-row align="center" class="ma-0">
                            <h2 v-once class="section-title">Источники</h2>
                            <HintIcon v-once hintId="connectors" class="ml-2"></HintIcon>
                            <v-spacer></v-spacer>
                            <v-btn
                                elevation="0"
                                color="mainNew"
                                class="white--text btn-w-icon"
                                @click="addConector"
                                v-if="checkRole(project.id, 'project:connector:edit')"
                                :disabled="!checkRole(project.id, 'project:connector:edit')"
                            >
                                <v-icon class="mr-5px"> mdi-plus </v-icon>Добавить источник
                            </v-btn>
                            <ChangeViewBtn
                                :value="connectorsView"
                                @input="updateConnectorsView"
                                :cacheKey="'connectorsView'"
                                class="ml-4"
                            ></ChangeViewBtn>
                        </v-row>
                    </div>
                    <div v-if="connectorsView === 'cards'" class="mt-4">
                        <v-row 
                            v-for="i in Math.ceil(allConnectors.length / 3)" 
                            :key="`connector-${i}`" 
                            class="ma-0"
                        >
                            <ConnectorCard
                                v-for="(connector, j) in allConnectors.slice((i - 1) * 3, i * 3)"
                                class="my-2"
                                :class="j % 3 === 1 ? 'mx-4' : ''"
                                :key="connector.connectorId"
                                :connector="connector"
                                :selectedConnectors="selectedConnectors"
                                :loading="connector.loading"
                                @openConnectorSettings="openConnectorSettings"
                                @deleteConnector="deleteConnector"
                            ></ConnectorCard>
                        </v-row>
                    </div>
                    <ConnectorsListView
                        v-if="connectorsView === 'list'"
                        :connectors="allConnectors"
                        :value="selectedConnectors"
                        @input="selectedConnectors = $event"
                        @openConnectorSettings="openConnectorSettings"
                        @deleteConnector="deleteConnector"
                    ></ConnectorsListView>
                </div>
            </div>
        </div>
        <CascadeSetupModal
            v-model="showCascadeModal"
            @skip="onCascadeSkip"
            @connect-second-channel="onConnectSecondChannel"
        />
        <ChannelSelectionModal
            v-model="showChannelSelection"
            :showCancel="true"
            @confirm="onChannelConfirm"
            @cancel="onChannelCancel"
        />
        <!-- Сайдбар оплаты: add-channel только при наличии контекста канала -->
        <PaymentSidebar
            v-if="project.billingEnabled"
            :renewal="paymentModalRenewal"
            :mode="paymentSidebarMode"
        />
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useConfirmStore } from '../store/stores/confirm'
import { useMessengerStore } from '../store/stores/messenger'

import Breadcrumbs from '@/components/Breadcrumbs'
import HintIcon from '@/components/HintIcon'
import AssignPermissionBtn from '@/components/buttons/AssignPermissionBtn'
import ChangeViewBtn from '@/components/buttons/ChangeViewBtn'
import CardsViewDashboards from '@/components/project/CardsViewDashboards'
import ConnectorCard from '@/components/project/ConnectorCard'
import InactiveChannelCard from '@/components/project/InactiveChannelCard.vue'
import ConnectorsListView from '@/components/project/ConnectorsListView'
import DashboardCard from '@/components/project/DashboardCard'
import ListViewDashboards from '@/components/project/ListViewDashboards'
import AddUserDialog from '@/components/project/dialogs/AddUserDialog'
import RenameUserDialog from '@/components/project/dialogs/RenameUserDialog'
import { checkAccess } from '@/utils'
import { mapGetters, mapState } from 'vuex'
import cfg from '../../config'
import DemoSubView from './GCB2/subViews/DemoSubView.vue'
import OnBoarding from '../components/project/onBoarding/OnBoarding.vue'

import RenameProjectBtn from '@/components/buttons/RenameProjectBtn'
import ProjectSettingsBtn from '@/components/project/ProjectSettingsBtn.vue'
import ProjectHeaderHintBtn from '@/components/project/ProjectHeaderHintBtn.vue'
import StarterPackPromoCard from '@/components/project/StarterPackPromoCard.vue'
import { computed, onMounted, ref } from 'vue'
import ScheduledReportSection from '../components/project/scheduledReport/ScheduledReportSection.vue'
import Stories from '../components/stories/Stories.vue'
import { checkRole, hasLorealCluster } from '../helpers/roles'
import { hasGcb2ChatViewAccess } from '@/helpers/gcb2/chatAccess'
import { hasYClientsConnector } from '@/helpers/gcb2/yclientsOnly'
import { useProject } from '../hooks/useProject'
import { useProjectBillingStatus } from '../hooks/useProjectBillingStatus'
import { useAppMobileBillingLock } from '../hooks/useAppMobileBillingLock'
import project from '../store/project'
import { useBillingStore } from '../store/stores/billing'
import { CONNECTOR_TYPES, PROVIDER_TYPES, CHANNEL_TYPES, PROVIDER_TO_CHANNEL_MAP, GCB_EXTERNAL_CONNECTOR_TYPES, TELEPHONY_CONNECTOR_TYPES } from '../vars/general'
import {
    getChannelGroupByChannelType,
    getProjectChannelGroups,
} from '@/helpers/channels/channelCatalog'
import DeleteConnectorConfirm from '../components/project/dialogs/DeleteConnectorConfirm.vue'
import VideoHelper from '../components/VideoHelper.vue'
import UserList from '../components/project/UserList.vue'
import ChannelsTabs from '../components/project/ChannelsTabs.vue'
import CascadeSetupModal from '@/components/project/onBoarding/CascadeSetupModal.vue'
import ChannelSelectionModal from '@/components/project/onBoarding/ChannelSelectionModal.vue'
import PaymentSidebar from '@/modules/marketplace/components/billing/PaymentSidebar.vue'
import maxLogo from '@/assets/img/messenger-logo/max-logo.svg'
import hotWindowsIcon from '@/assets/img/hot-windows/hot-windows-icon.png'
import {
    getProjectChatBotConnectors,
    syncSubscribersGrowthFirstChatBotAnchor,
    computeSubscribersGrowthShowNewBadge,
} from '@/utils/subscribersGrowthWidget'
import { getStarterPackStatus } from '@/modules/StarterPack/api'
import { logChannelSettingsOpened } from '@/helpers/ymLogger'
import { openChannelCreationSidebar } from '@/helpers/channels/openChannelCreationSidebar'
import {
    isTruthyQueryValue,
    OPEN_ADD_CHANNEL_BILLING_QUERY,
    OPEN_CHANNEL_CREATION_QUERY,
} from '@/helpers/projects/connectMailingChannel'
export default {
    name: 'Project',
    components: {
        OnBoarding,
        DashboardCard,
        ConnectorCard,
        InactiveChannelCard,
        AddUserDialog,
        RenameUserDialog,
        Breadcrumbs,
        ChangeViewBtn,
        CardsViewDashboards,
        ListViewDashboards,
        ConnectorsListView,
        HintIcon,
        AssignPermissionBtn,
        RenameProjectBtn,
        ProjectSettingsBtn,
        ProjectHeaderHintBtn,
        StarterPackPromoCard,
        ScheduledReportSection,
        Stories,
        DemoSubView,
        DeleteConnectorConfirm,
        VideoHelper,
        UserList,
        ChannelsTabs,
        CascadeSetupModal,
        ChannelSelectionModal,
        PaymentSidebar,
    },
    setup(props, { emit }) {
        const { project } = useProject()
        const billingStore = useBillingStore()
        const {
            projectStatus,
            isBillingBlocked,
            isProjectContentAvailable,
            isBeautyAutopilotOnly,
            currentTariff,
            isTrialActivatedBefore,
        } = useProjectBillingStatus()
        const { showAppMobileBillingLock } = useAppMobileBillingLock()
        const showLocalBillingLock = computed(
            () => Boolean(isBillingBlocked.value && !showAppMobileBillingLock.value)
        )
        return {
            project,
            billingStore,
            projectStatus,
            isBillingBlocked,
            showLocalBillingLock,
            isProjectContentAvailable,
            isBeautyAutopilotOnly,
            currentTariff,
            isTrialActivatedBefore,
        }
    },
    data: () => ({
        dashBoardsView: 'cards',
        channelsView: 'cards',
        connectorsView: 'cards',
        loadingValue: null,
        loadingInterval: null,
        selectedConnectors: [],
        selectedUsers: [],
        deleteConectorConfirmIsOpen : false,
        connectorsForDelete : [],
        showVideoHelp: true,
        showVideoHelpStories: false,
        showCascadeModal: false,
        showChannelSelection: false,
        selectedCascadeChannelType: null,
        starterPackScenarioTotal: 0,
        starterPackScenarioActive: 0,
        starterPackScenariosLoading: false,
    }),

    computed: {
        ...mapGetters(['projectById']),
        ...mapStores(useConfirmStore, useMessengerStore),
        overlayStyle() {
            if (
                this.projectStatus === 'open' ||
                this.projectStatus === 'beforeTrial' ||
                this.projectStatus === 'beautyAutopilotOnly'
            ) {
            return {
                backgroundImage: 'linear-gradient(120deg, #1E2B6E 0%, #3A2D8C 55%, #5B4BB0 100%)',
                backgroundSize: 'cover',
                backgroundPosition: 'center top',
                backgroundRepeat: 'no-repeat',
            }
        }

        return {
            backgroundImage: this.tariffNearToEnd
                ? `url(${require('@/assets/img/project/project-overview-billing-beforEnd.svg')})`
                : `url(${require('@/assets/img/project/project-overview-billing-dangeour.svg')})`,
            backgroundColor: this.tariffNearToEnd ? '#FF711C' : 'red',
            backgroundSize: 'cover',
            backgroundPosition: 'center top',
            backgroundRepeat: 'no-repeat',
        }
        },
        paymentModalRenewal() {
            return this.billingStore.paymentModal.renewal
        },
        paymentSidebarMode() {
            return this.billingStore.addChannelContext?.name ? 'add-channel' : 'billing'
        },
        project() {
            const projectId = this.$route?.params?.id
            return this.$store.getters.projectById(projectId)
        },
        isHrProject() {
            return this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)?.hrProject || false
        },
        GCB2Connector() {
            return this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
        },
        hasDhChatAccess() {
            return hasGcb2ChatViewAccess(this.project)
        },
        chatUnreadBadge() {
            if (!this.hasDhChatAccess || this.messengerStore.projectId !== this.project.id) return 0
            return this.messengerStore.projectUnreadCount || 0
        },
        isVideoHintHidden() {
            return this.GCB2Connector?.videoHintDisabled
        },
        breadcrumbs() {
            return [
                {
                    text: 'Ваши проекты',
                    to: '/projects',
                },
                {
                    text: this.project.name,
                    to: '',
                    disabled: true,
                },
            ]
        },
        diffTariifDays() {
            if (this.currentTariff?.activeUntil) {
                const today = new Date()
                const activaUntil = new Date(this.currentTariff?.activeUntil)
                return Math.floor((today - activaUntil) / (60 * 60 * 24 * 1000)) * -1
            } else {
                return this.currentTariff?.daysLeft || 0
            }
        },
        tariffNearToEnd() {
            if (!this.currentTariff) return false

            if (this.diffTariifDays < 4 && this.diffTariifDays > 0) return true
            else return false
        },
        showStarterPackPromo() {
            return !this.isBeautyAutopilotOnly && checkRole(this.project.id, 'project:settings:view')
        },
        trialDaysLeft() {
            return this.currentTariff?.daysLeft || 0
        },
        starterPackUrl() {
            return `${this.$router.currentRoute.path}/GCB2/starterPack`
        },
        tariffChannelLimit() {
            if (!this.project.billingEnabled) return 1
            const tariff = this.currentTariff
            if (!tariff || this.isBillingBlocked) return 0
            const billingTariff = this.billingStore.getTariffById(tariff.integrationId)
            const raw = [
                tariff.integrationId,
                tariff.name,
                billingTariff?.id,
                billingTariff?.name,
                ...(billingTariff?.tags || []),
            ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase()

            if (raw.includes('tariff3') || /тариф\s*3/.test(raw)) return 3
            if (raw.includes('tariff2') || /тариф\s*2/.test(raw)) return 3
            if (raw.includes('tariff1') || /тариф\s*1/.test(raw)) return 1
            return 1
        },
        dashBoards() {
            return [
                {
                    id: 'GCB2',
                    name: this.isHrProject 
                        ? 'Рассылка сотрудникам' 
                        : (this.project.isChannelsRework ? 'Рассылки по базе клиентов' : 'Кого из клиентов стоит позвать'),
                    path: '/GCB2',
                    type: 'communications',
                    icon: {
                        color: 'linear-gradient(145deg, #CF96F0 0%, #A768D8 52%, #8850CA 100%)',
                        name: '$clients',
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled && this.projectStatus === 'open',
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Рассылки, звонки и аналитика',
                    hintLink: this.isHrProject ? null : 'https://dataheroes.platrum.ru/help?slug=4690-kogo-iz-klientov-stoit-pozvat-kopiya'
                },
                {
                    id: 'Callbot',
                    name: 'Аудиорассылки DH',
                    path: '/callbot',
                    type: 'communications',
                    icon: {
                        color: 'linear-gradient(145deg, #CF96F0 0%, #A768D8 52%, #8850CA 100%)',
                        name: 'mdi-phone-in-talk-outline',
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled && this.projectStatus === 'open',
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Аудиорассылки, задачи и аналитика',
                    showNewBadge: true,
                },
                {
                    id: 'ClientNotifications',
                    name: 'Сервисные уведомления',
                    path: '/clientNotifications',
                    type: 'communications',
                    icon: {
                        color: 'linear-gradient(145deg, #CF96F0 0%, #A768D8 52%, #8850CA 100%)',
                        name: 'mdi-bell-outline',
                    },
                    show: this.projectStatus === 'open' &&
                          this.project.isChannelsRework && 
                          this.project.connectors.some(con => con.connectorType === CONNECTOR_TYPES.whatsappBasis),
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Общие настройки бота и всех сервисных уведомлений',
                },
                {
                    id: 'DhClientChat',
                    name: 'Мультичат',
                    path: '/GCB2?section=chat&fs=1',
                    type: 'communications',
                    icon: {
                        color: 'linear-gradient(145deg, #CF96F0 0%, #A768D8 52%, #8850CA 100%)',
                        name: 'mdi-chat-processing-outline',
                    },
                    show: this.projectStatus === 'open' && hasGcb2ChatViewAccess(this.project),
                    requiredConnectorTypes: [],
                    description: 'Единый центр общения с клиентом, все чаты в одном месте',
                    badgeCount: this.chatUnreadBadge,
                    showNewBadge: true,
                },
                {
                    id: 'GCB2SubscribersGrowth',
                    name: '👉 Прирост подписчиков',
                    path: '/GCB2/subscribersGrowth',
                    type: 'communications',
                    icon: {
                        color: 'linear-gradient(145deg, #CF96F0 0%, #A768D8 52%, #8850CA 100%)',
                        image: maxLogo,
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        this.projectStatus === 'open' &&
                        getProjectChatBotConnectors(this.project.connectors).length > 0 &&
                        this.checkRole(this.project.id, 'gcb2:subscribersGrowth:view'),
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Динамика подключений в МАХ Business',
                    showNewBadge: computeSubscribersGrowthShowNewBadge(
                        this.project.id,
                        this.project.connectors
                    ),
                },
                {
                    id: 'GCB2HotWindows',
                    name: 'Горячие окна',
                    path: '/GCB2/hotWindows',
                    type: 'communications',
                    icon: {
                        image: hotWindowsIcon,
                        fullBleedImage: true,
                    },
                    // Без checkRole по образцу Звонобота: gcb2:hotWindows:view/edit
                    // жили в таблице permission и per-project redis-кэше на 24ч —
                    // на проекте с уже прогретым кэшем виджет не появлялся сутки
                    // после включения тумблера в админке.
                    show:
                        this.projectStatus === 'open' &&
                        hasYClientsConnector(this.project) &&
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled,
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Заполняйте свободные окна. Система сама предложит кандидатов.',
                    showNewBadge: true,
                },
                {
                    id: 'SendingSchemes',
                    name: 'Настройка схем отправки',
                    path: '#channels-tabs',
                    type: 'communications',
                    icon: {
                        color: 'linear-gradient(145deg, #CF96F0 0%, #A768D8 52%, #8850CA 100%)',
                        name: 'mdi-cog-outline',
                    },
                    show: this.projectStatus === 'open' && this.project.isChannelsRework,
                    requiredConnectorTypes: [],
                    description: 'Каналы отправки, каскад',
                },
                {
                    id: 'GCB2BusinessPulseReport',
                    name: 'Отчёт 2.0',
                    path: '/GCB2/businessPulseReport',
                    type: 'analytics',
                    // Флаг businessPulseReport проверяется на самой странице отчёта:
                    // без покупки виджет остаётся, а внутри показывается экран подключения.
                    show:
                        hasYClientsConnector(this.project) &&
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        checkRole(this.project.id, 'gcb2:analytics:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #756BE8 0%, #5550BE 54%, #3C3695 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description:
                        'Пульс вашего бизнеса. 17 показателей, графики и возможность сравнения с другими периодами',
                    showNewBadge: true,
                    hintLink: ''
                },
                {
                    id: 'GCB2Returnability',
                    name: 'Обзор удержания клиентов',
                    path: '/GCB2/returnability',
                    type: 'analytics',
                    show: this.checkRole(this.project.id, 'returnability:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Отчёт по возвращаемости клиентов к мастерам и на услуги',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4747-uderzhanie-klientov-kopiya'
                },
                {
                    id: 'GCB2MarketingReport',
                    name: 'Возвращаемость новых клиентов',
                    path: '/GCB2/marketingReport',
                    type: 'analytics',
                    show: checkRole(this.project.id, 'marketingReport:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$marketingReport',
                        size: 30,
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Какая доля новых клиентов возвращается после первого визита в разрезе каждого специалиста',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4748-kogortnyj-analiz-kopiya'
                },

                {
                    id: 'GCB2Churn',
                    name: 'После кого уходят клиенты',
                    path: '/GCB2/churn',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled && checkRole(this.project.id, 'gcb2:churnReport:view'),
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Отчет по клиентам, которые перестали ходить после посещения конкретного специалиста',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4752-posle-kakih-sotrudnikov-uhodyat-klienty-kopiya'
                },
                {
                    id: 'GCB2Staff',
                    name: 'Отчет по мастерам',
                    path: '/GCB2/staff',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show:
                        this.GCB2Connector &&
                        !this.GCB2Connector?.disabled &&
                        checkRole(this.project.id, 'gcb2:staffReport:view'),

                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Отчёт по работе мастеров',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4754-otchet-po-masteram-kopiya'
                },
                {
                    id: 'GCB2SameDayRec',
                    name: 'ОПЗ',
                    path: '/GCB2/sameDayRec',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        this.project.connectors.some(
                            (con) => con.connectorType === CONNECTOR_TYPES.yClients
                        ),
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Отчёт по перезаписям клиентов после оказания услуг',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4761-otchet-opz-kopiya'
                },
                {
                    id: 'GCB2Fourhands',
                    name: 'Отчет для 4hands',
                    path: '/GCB2/fourhandsReport',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.showFourhandsReport,
                    //requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'GCB2Persona',
                    name: 'Отчет Персона',
                    path: '/GCB2/personaReport',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.showPersonaReport,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'GCB2ActivationReport',
                    name: 'Отчет по активациям',
                    path: '/GCB2/adminReportActivation',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show: this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                        ?.showActivationReport,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'GCB2SimpleReports',
                    name: 'Общие отчеты',
                    path: '/GCB2/simpleReports',
                    type: 'analytics',
                    show: checkRole(this.project.id, 'simpleReports:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Набор метрик с разбивкой по годам',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4753-obshie-otchety-kopiya'
                },

                {
                    id: 'GCB2doctorReport',
                    name: 'Доктор DH',
                    path: '/GCB2/doctorReport',
                    type: 'analytics',
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled && 
                        checkRole(this.project.id, 'gcb2:doctorReport:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #756BE8 0%, #5550BE 54%, #3C3695 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Отчёт, показывающий состояние вашего бизнеса на сегодняшний день',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4762-doktor-dh-kopiya'
                },

                {
                    id: 'GCB2doctorReportLoreal',
                    name: 'Доктор для Лореаль',
                    path: '/GCB2/doctorReportLoreal',
                    type: 'analytics',
                    type: 'analytics',
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        hasLorealCluster(this.project.id),
                    icon: {
                        color: 'linear-gradient(145deg, #FF8A5B 0%, #FF6B35 52%, #E85A28 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Отчёт для Лореаль с детализацией по залам и группам услуг',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=doctor-loreal'
                },

                {
                    id: 'GCB2StaffTurnover',
                    name: 'Отчет по текучести кадров',
                    path: '/GCB2/staffTurnover',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show: this.isHrProject,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'GCB2StaffTrajectory',
                    name: 'Отчет траектории сотрудников',
                    path: '/GCB2/staffTrajectory',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show: this.isHrProject,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'GCB2AvgCheckReport',
                    name: 'Отчет по среднему чеку',
                    path: '/GCB2/avgCheckReport',
                    type: 'analytics',
                    show:
                        !this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.disabled &&
                        this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                            ?.showAvgCheckReport &&
                        checkRole(this.project.id, 'gcb2:avgCheckReport:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'GCB2WhereIsMyClients',
                    name: 'Почему теряются новые клиенты?',
                    path: '/GCB2/whereIsMyClients',
                    type: 'analytics',
                    show: checkRole(this.project.id, 'simpleReports:view') && this.limitedAccessProjects,
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Покажем, сколько денег Вы теряете, когда звонки не превращаются в записи',
                    hintLink: ''
                },
                {
                    id: 'StarterPack',
                    name: 'Старт в DH',
                    path: '/GCB2/starterPack',
                    type: 'analytics',
                    show: false,
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'BeautyAutopilot',
                    name: 'Beauty Autopilot',
                    path: '/GCB2/BeautyAutopilot',
                    type: 'analytics',
                    icon: {
                        color: 'linear-gradient(145deg, #BDE36F 0%, #8BC64A 54%, #69A936 100%)',
                        name: '$analytics',
                    },
                    show: this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
                      ?.showBeautyAutopilot,
                    description: '',
                    hintLink: ''
                },
                {
                    id: 'rolesSettings',
                    name: 'Гибкая настройка прав доступа',
                    path: '/settings/roles',
                    type: 'settings',
                    show: checkRole(this.project.id, 'project:rolesSettings:view'),
                    icon: {
                        color: 'linear-gradient(145deg, #FFD96B 0%, #FFBB3B 52%, #F2A11C 100%)',
                        name: 'mdi-cog',
                    },
                    description: 'Настройки доступа для работающих в проекте администраторов',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4760-gibkaya-nastrojka-prav-dostupa-kopiya'
                },
                {
                    id: 'GCB2KpiDasboard',
                    name: 'KPI сотрудников',
                    path: '/GCB2/kpi',
                    type: 'settings',
                    show:
                        this.checkRole(this.project.id, 'gcb2:kpi:view') ||
                        this.checkRole(this.project.id, 'gcb2:kpi:edit'),
                    icon: {
                        color: 'linear-gradient(145deg, #FFD96B 0%, #FFBB3B 52%, #F2A11C 100%)',
                        name: '$money',
                    },
                    requiredConnectorTypes: GCB_EXTERNAL_CONNECTOR_TYPES,
                    description: 'Расчёт KPI и настройка схем расчёта KPI',
                    hintLink: 'https://dataheroes.platrum.ru/help?slug=4759-kpi-sotrudnikov-kopiya'
                },
                {
                    id: 'taggingSetvices',
                    name: 'Тегирование услуг',
                    path: '/GCB2/taggingServices',
                    type: 'settings',
                    show: this.isSuperUser,
                    icon: {
                        color: 'linear-gradient(145deg, #FFD96B 0%, #FFBB3B 52%, #F2A11C 100%)',
                        name: 'mdi-tag-text',
                    },
                    description: 'Настройка тегов услуг для отчетов и сегментации',
                    hintLink: null
                },
                {
                    id: 'marketplace',
                    name: 'Маркетплейс Data Heroes',
                    type: 'marketplace',
                    path: '/marketplace',
                    show: false,
                    icon: {
                        color: 'linear-gradient(145deg, #5BB5F0 0%, #238ee7 54%, #1A6FBE 100%)',
                        name: '$marketplace',
                    },
                    description: '',
                    hintLink: ''
                },
            ].filter((dashboard) => {
                const enabledInCfg = cfg.disabledDashboardsIds
                    ? !cfg.disabledDashboardsIds.includes(dashboard.id)
                    : true
                // «Только BA»: в проекте один виджет — Beauty Autopilot.
                if (this.isBeautyAutopilotOnly && dashboard.id !== 'BeautyAutopilot') return false
                return enabledInCfg && dashboard.show
            })
        },
        myRole() {
            if (this.project.users.find((user) => user.id === this.$auth.user.sub)) {
                return this.project.users.find((user) => user.id === this.$auth.user.sub).role.id
            }
            return 'observer'
        },
        isAddUserDialog: {
            get() {
                return this.$store.state.project.isAddUserDialog
            },
            set(value) {
                this.$store.commit('project/updateIsAddUserDialog', value)
            },
        },
        limitedAccessProjects() {
            return cfg.buildType !== 'PRODUCTION' || ['FXK93110T', 'QYXDUF2V6', 'LXCHNJLQX'].includes(this.project.id)
        },
        isSuperUser() {
            return cfg.adminsWhitelist.includes(this.$auth.user.sub)
        },
        channels() {
            // Только для новой логики (isChannelsRework)
            if (!this.project.isChannelsRework) return []
            
            // Фильтруем каналы: либо connectorType из CHANNEL_TYPES, либо из PROVIDER_TYPES (для обратной совместимости), либо telegramHr
            // whatsappBasis исключаем - он отображается в источниках
            // whatsapp (рассылки) теперь просто провайдер внутри группы WhatsApp, не отдельный канал
            // telegramHrBranch показываем только суперпользователю
            const channelTypes = Object.values(CHANNEL_TYPES)
            const providerTypes = Object.values(PROVIDER_TYPES)
            return this.project.connectors.filter(c => 
                !c.isChisai && 
                c.connectorType !== CONNECTOR_TYPES.whatsappBasis && // Исключаем whatsappBasis - он в источниках
                (
                    channelTypes.includes(c.connectorType) || 
                    providerTypes.includes(c.connectorType) ||
                    c.connectorType === CONNECTOR_TYPES.telegramHr ||
                    (c.connectorType === CONNECTOR_TYPES.telegramHrBranch && this.isSuperUser)
                )
            )
        },
        connectors() {
            // Исключаем каналы (CHANNEL_TYPES и PROVIDER_TYPES для обратной совместимости), телефонию и telegramHr
            // whatsappBasis включаем в источники только если НЕ isChannelsRework
            // telegramHrBranch в источниках показываем только суперпользователю и только для старой логики (без isChannelsRework)
            const channelTypes = Object.values(CHANNEL_TYPES)
            const providerTypes = Object.values(PROVIDER_TYPES)
            return this.project.connectors.filter(c => 
                !c.isChisai && 
                !channelTypes.includes(c.connectorType) &&
                // Исключаем providerTypes, но включаем whatsappBasis обратно только если НЕ isChannelsRework
                (!providerTypes.includes(c.connectorType) || (c.connectorType === CONNECTOR_TYPES.whatsappBasis && !this.project.isChannelsRework)) &&
                !TELEPHONY_CONNECTOR_TYPES.includes(c.connectorType) &&
                c.connectorType !== CONNECTOR_TYPES.telegramHr &&
                (c.connectorType !== CONNECTOR_TYPES.telegramHrBranch || this.isSuperUser)
            )
        },
        telephonyConnectors() {
            // Только для новой логики (isChannelsRework)
            if (!this.project.isChannelsRework) return []
            
            return this.project.connectors.filter(c => 
                !c.isChisai && TELEPHONY_CONNECTOR_TYPES.includes(c.connectorType)
            )
        },
        allTelephonyCards() {
            // Только для новой логики (isChannelsRework)
            if (!this.project.isChannelsRework) return []
            
            const activeTelephony = this.telephonyConnectors
            const cards = []
            
            // Добавляем активные телефонии
            activeTelephony.forEach(connector => {
                cards.push({
                    isActive: true,
                    connector,
                    key: connector.connectorId,
                    loading: connector.loading,
                })
            })
            
            // Если нет ни одной активной телефонии, показываем все неактивные карточки
            if (activeTelephony.length === 0) {
                TELEPHONY_CONNECTOR_TYPES.forEach(connectorType => {
                    cards.push({
                        isActive: false,
                        connectorType,
                        key: `inactive-telephony-${connectorType}`,
                    })
                })
            }
            
            return cards
        },
        allSourcesCards() {
            // Только для новой логики (isChannelsRework)
            if (!this.project.isChannelsRework) return []
            
            const activeSources = this.connectors
            const cards = []
            
            // Добавляем активные источники
            activeSources.forEach(connector => {
                cards.push({
                    isActive: true,
                    connector,
                    key: connector.connectorId,
                    loading: connector.loading,
                })
            })
            
            // Если нет ни одного активного источника, показываем все неактивные карточки из GCB_EXTERNAL_CONNECTOR_TYPES
            // Исключаем lenaLenina и profSalon - они не должны быть среди неактивных
            if (activeSources.length === 0) {
                GCB_EXTERNAL_CONNECTOR_TYPES
                    .filter(connectorType => 
                        connectorType !== CONNECTOR_TYPES.lenaLenina && 
                        connectorType !== CONNECTOR_TYPES.profSalon
                    )
                    .forEach(connectorType => {
                        cards.push({
                            isActive: false,
                            connectorType,
                            key: `inactive-source-${connectorType}`,
                        })
                    })
            }
            
            return cards
        },
        allConnectors() {
            // Для старой логики - все коннекторы вместе (источники, каналы, телефония)
            if (this.project.isChannelsRework) return []
            return this.project.connectors.filter(c => 
                !c.isChisai &&
                // telegramHrBranch в старом отображении показываем только суперпользователю
                (c.connectorType !== CONNECTOR_TYPES.telegramHrBranch || this.isSuperUser)
            )
        },
        allChannelsCards() {
            // Только для новой логики (isChannelsRework)
            if (!this.project.isChannelsRework) return []
            
            const activeChannels = this.channels
            const cards = []
            
            // Лимит каналов по тарифу: tariff1 → 1, tariff2/3 → 3, без тарифа → 0
            // В лимит входят только каналы с connectorType === whatsappChannel, telegramChannel или maxChannel
            const FREE_CHANNELS_LIMIT = this.tariffChannelLimit
            const limitedChannelTypes = [
                CHANNEL_TYPES.whatsappChannel,
                CHANNEL_TYPES.telegramChannel,
                CHANNEL_TYPES.maxChannel,
                CHANNEL_TYPES.maxBusiness,
                CHANNEL_TYPES.smsChannel,
            ]
            const eligibleActiveChannels = activeChannels.filter(c =>
                limitedChannelTypes.includes(c.connectorType)
            )
            const totalActiveChannels = eligibleActiveChannels.length
            const remainingFreeSlots = Math.max(0, FREE_CHANNELS_LIMIT - totalActiveChannels)
            // Сколько бесплатных слотов доступно для будущих (неактивных) каналов
            let freeSlotsForInactive = remainingFreeSlots
            
            // Группы каналов
            // whatsappBasis исключен - он отображается в источниках
            const channelGroups = getProjectChannelGroups()
            
            // Добавляем активные каналы
            activeChannels.forEach(connector => {
                cards.push({
                    isActive: true,
                    connector,
                    key: connector.connectorId,
                    loading: connector.loading,
                })
            })
            
            // Для каждой группы проверяем количество подключенных и добавляем неактивные
            channelGroups.forEach(group => {
                // Определяем targetChannelType из CHANNEL_TYPES для этой группы
                let targetChannelType = null
                targetChannelType = group.channelConnectorType
                
                // Считаем только каналы с connectorType из CHANNEL_TYPES
                const connectedInGroup = activeChannels.filter(c => {
                    return c.connectorType === targetChannelType
                })
                const connectedCount = connectedInGroup.length
                
                // Всегда показываем неактивную карточку для следующего экземпляра
                // Будущий индекс = connectedCount + 1
                const futureIndex = connectedCount + 1
                
                // Определяем тип для следующего канала
                let nextChannelType = group.defaultType
                
                // Для WhatsApp (обычный): если подключен один тип, следующий будет другой тип
                if (group.name === 'whatsapp' && connectedCount > 0 && connectedCount < group.channelTypes.length) {
                    // Получаем подключенные типы провайдеров
                    const connectedTypes = connectedInGroup.map(c => c.providerType || c.connectorType)
                    nextChannelType = group.channelTypes.find(t => !connectedTypes.includes(t)) || group.defaultType
                }
                // Если все типы группы уже подключены, используем первый тип группы для следующих экземпляров
                else if (connectedCount >= group.channelTypes.length) {
                    nextChannelType = group.defaultType
                }
                
                // isAdditional = true, если это платный канал.
                // Бесплатный лимит общий для всех типов каналов, не более FREE_CHANNELS_LIMIT штук.
                let isAdditional = false
                if (futureIndex > 1 || freeSlotsForInactive <= 0) {
                    // Уже есть канал этого типа, или бесплатные слоты кончились
                    isAdditional = true
                } else {
                    // Первый канал этого типа и ещё есть глобальный бесплатный слот
                    freeSlotsForInactive -= 1
                    isAdditional = false
                }
                
                cards.push({
                    isActive: false,
                    channelType: nextChannelType,
                    isAdditional: isAdditional,
                    futureIndex: futureIndex,
                    key: `inactive-${group.name}-${futureIndex}`,
                })
            })
            
            return cards
        },
        yClientsConnector() {
            return this.$store.getters
                .projectById(this.$router.currentRoute.params.id)
                .connectors.find((el) => el.connectorType === CONNECTOR_TYPES.yClients);
        },
    },
    watch: {
        channelsView() {
            this.selectedConnectors = []
        },
        connectorsView() {
            this.selectedConnectors = []
        },
        'project.connectors': {
            deep: true,
            immediate: true,
            handler() {
                if (!this.project?.id) return
                syncSubscribersGrowthFirstChatBotAnchor(this.project.id, this.project.connectors)
                this.fetchDhChatUnreadCount()
            },
        },
    },
    methods: {
        checkAccess,
        checkRole,
        async fetchDhChatUnreadCount() {
            if (!this.project?.id || !this.hasDhChatAccess) return
            this.messengerStore.setProjectId(this.project.id)
            this.messengerStore.setOmnichannel(true)
            await this.messengerStore.fetchProjectUnreadCount()
        },
        goToProjects() {
            this.$router.push({ path: '/projects' })
        },
        addConector() {
            const currentPath = this.$router.currentRoute.path.split('?')[0] // Убираем query параметры из пути
            sessionStorage.setItem('afterAddConnectorRedirectPath', currentPath)
            // Очищаем currentAddingConnector и loggedAddingConnector в store, чтобы не использовались данные из предыдущего клика
            this.$store.commit('project/updateCurrentAddingConnector', null)
            this.$store.commit('project/setLoggedAddingConnector', null)
            // Переходим без query параметров, чтобы не фильтровался список коннекторов
            this.$router.push({
                path: `${currentPath}/addConnectorStage1`,
                query: {} // Явно очищаем query параметры
            })
        },
        selectConnector(connector) {
            if (!this.checkRole(this.project.id, 'project:connector:delete')) {
                return
            }
            if (!this.selectedConnectors.includes(connector.connectorId)) {
                this.selectedConnectors.push(connector.connectorId)
            } else {
                const index = this.selectedConnectors.findIndex(
                    (connectorId) => connectorId === connector.connectorId
                )
                this.selectedConnectors.splice(index, 1)
            }
        },
        clearSelectedUsers() {
            this.$emit('clearSelectedUsersCheckBoxes')
            this.selectedUsers = []
        },
        test(a) {
            console.log(a)
        },
        async deleteConnector(connectorId) {
            this.connectorsForDelete = [connectorId]
            this.deleteConectorConfirmIsOpen = true
        },
        openConnectorSettings(connectorId) {
            this.$router.push(`${this.$router.currentRoute.path}/connectorSettings/${connectorId}`)
        },
        openConnectorSettingsInSidebar(connectorId) {
            // Открываем сайдбар с настройками коннектора
            const connector = this.$store.getters['connectorById'](connectorId)
            logChannelSettingsOpened(connectorId, connector?.providerType ?? connector?.botProvider ?? null)
            this.$store.commit('setConnectorSettingsSidebarId', connectorId)
            this.$store.commit('setIsConnectorSettingsSidebar', true)
            // Сбрасываем режим создания канала, если он был активен
            this.$store.commit('setChannelCreationMode', false)
            this.$store.commit('setChannelCreationStage', null)
        },
        setVideoHelepVisible(value) {
            this.showVideoHelp = value
        },
        setVideoHelepStoriesVisible(value) {
            if(this.showVideoHelp) {
                this.showVideoHelp = false
            }
            this.showVideoHelpStories = value
        },
        editUsersFromChild(value) {
            this.selectedUsers = value
        },
        updateConnectorsView(value) {
            this.connectorsView = value
            this.selectedConnectors = []
        },
        onCascadeSkip() {
            this.showCascadeModal = false
        },
        /** Скролл почти в низ страницы (на offsetFromBottom px выше самого низа).
         * На мобилке по умолчанию 800px, на десктопе — 200px. */
        scrollNearPageBottom(offsetFromBottom) {
            const isMobile = window.matchMedia('(max-width: 640px)').matches
            const bottomOffset =
                typeof offsetFromBottom === 'number'
                    ? offsetFromBottom
                    : isMobile
                      ? 800
                      : 200
            let attempts = 0
            const maxAttempts = 30
            const tryScroll = () => {
                attempts += 1
                const scrollHeight = Math.max(
                    document.body?.scrollHeight || 0,
                    document.documentElement?.scrollHeight || 0,
                    document.scrollingElement?.scrollHeight || 0,
                )
                const maxScroll = Math.max(0, scrollHeight - window.innerHeight)
                // Ждём, пока контент реально отрисуется (иначе maxScroll ≈ 0 и остаёмся вверху)
                if (maxScroll < 50 && attempts < maxAttempts) {
                    setTimeout(tryScroll, 50)
                    return
                }
                const offset = Math.max(0, maxScroll - bottomOffset)
                this.$scrollTo(document.body, 400, { offset })
            }
            this.$nextTick(() => {
                requestAnimationFrame(tryScroll)
            })
        },
        handleOpenConnectorSidebarFromQuery() {
            const { query } = this.$router.currentRoute
            const connectorId = query.openConnectorSidebar
            if (!connectorId) {
                return
            }

            this.$router.replace({
                path: this.$router.currentRoute.path,
                query: Object.assign({}, query, { openConnectorSidebar: undefined }),
            })

            this.$nextTick(() => {
                this.openConnectorSettingsInSidebar(connectorId)
                this.scrollNearPageBottom()
            })
        },
        handleOpenChannelCreationFromQuery() {
            const { query } = this.$router.currentRoute
            if (!isTruthyQueryValue(query[OPEN_CHANNEL_CREATION_QUERY])) {
                return
            }

            const group = query.group || null
            const slotId = query.slotId || null
            const connectTab = query.connectTab === 'transfer' ? 'transfer' : 'new'

            this.$router.replace({
                path: this.$router.currentRoute.path,
                query: Object.assign({}, query, { [OPEN_CHANNEL_CREATION_QUERY]: undefined }),
            })

            this.$nextTick(() => {
                openChannelCreationSidebar(
                    this,
                    { group, _slotId: slotId },
                    connectTab,
                )
                this.scrollNearPageBottom()
            })
        },
        handleOpenAddChannelBillingFromQuery() {
            const { query } = this.$router.currentRoute
            if (!isTruthyQueryValue(query[OPEN_ADD_CHANNEL_BILLING_QUERY])) {
                return
            }

            this.$router.replace({
                path: this.$router.currentRoute.path,
                query: Object.assign({}, query, { [OPEN_ADD_CHANNEL_BILLING_QUERY]: undefined }),
            })

            this.$nextTick(() => {
                if (!this.project?.billingEnabled) {
                    this.$store.dispatch(
                        'callNotify',
                        'Для покупки дополнительного канала нужно включить биллинг в настройках проекта',
                    )
                    return
                }
                this.billingStore.setAddChannelContext({
                    name: 'WA/TG/MAX/SMS',
                    icon: null,
                    kind: 'bundle',
                })
                this.billingStore.setPaymentModalOpened(true, false)
            })
        },
        onConnectSecondChannel(channelType) {
            this.showCascadeModal = false
            // Канал выбран во втором шаге CascadeSetupModal — сразу открываем создание
            if (channelType) {
                this.onChannelConfirm(channelType)
                return
            }
            // fallback на старый флоу, если вызвали без типа
            this.showChannelSelection = true
        },
        onChannelConfirm(channelType) {
            this.showChannelSelection = false
            this.selectedCascadeChannelType = channelType
            // Как в таблице каналов: открываем сайдбар создания канала, без перехода на отдельную страницу
            let group = null
            group = getChannelGroupByChannelType(channelType)

            this.$store.commit('setChannelCreationMode', true)
            this.$store.commit('setChannelCreationStage', 1)

            // Force reopen: UI мог закрыться, даже если store=true
            const wasOpen = !!this.$store.state.isConnectorSettingsSidebar
            if (wasOpen) {
                this.$store.commit('setIsConnectorSettingsSidebar', false)
                this.$nextTick(() => {
                    this.$store.commit('setIsConnectorSettingsSidebar', true)
                })
            } else {
                this.$store.commit('setIsConnectorSettingsSidebar', true)
            }

            // Устанавливаем query параметр group без перезагрузки страницы
            if (group && this.$route?.query?.group !== group) {
                const newUrl = new URL(window.location.href)
                newUrl.searchParams.set('group', group)
                window.history.replaceState({}, '', newUrl.toString())
            }
        },
        onChannelCancel() {
            this.showChannelSelection = false
        },
        async fetchStarterPackProgress() {
            if (!this.showStarterPackPromo || !this.project?.id) {
                this.starterPackScenariosLoading = false
                this.starterPackScenarioTotal = 0
                this.starterPackScenarioActive = 0
                return
            }

            this.starterPackScenariosLoading = true
            try {
                const { data, error } = await getStarterPackStatus({ projectId: String(this.project.id) })
                if (error || !Array.isArray(data?.scenarios)) {
                    this.starterPackScenarioTotal = 0
                    this.starterPackScenarioActive = 0
                    return
                }

                const scenarios = data.scenarios
                this.starterPackScenarioTotal = scenarios.length
                this.starterPackScenarioActive = scenarios.filter(scenario => scenario.status === 'active').length
            } finally {
                this.starterPackScenariosLoading = false
            }
        },
    },
    async created() {
        if (this.project && !this.checkRole(this.project.id, 'project:connector:edit')) {
            this.connectorsView = 'cards'
        }
        this.$on('deleteConnector', this.deleteConnector)
        this.$on('openConnectorSettings', this.openConnectorSettings)
        this.$on('clearSelectedUsers', this.clearSelectedUsers)
    },
    async mounted() {
        const billingStore = useBillingStore()
        if (this.project.billingEnabled) {
            await Promise.all([
                billingStore.fetchCurrentTariff(this.project.id),
                billingStore.fetchTariffs(this.project.id),
            ])
        }
        if (this.showStarterPackPromo) {
            this.starterPackScenariosLoading = true
        }
        await this.fetchStarterPackProgress()
        //обработчик hash-ссылок
        if (this.$router.currentRoute.hash) {
            this.$scrollTo(this.$router.currentRoute.hash, 100, { offset: 500 })
        }

        // Показ модалки каскада после онбординга
        const { query } = this.$router.currentRoute
        if (query.showCascade === 'true') {
            this.$router.replace({
                path: this.$router.currentRoute.path,
                query: Object.assign({}, query, { showCascade: undefined }),
            })

            this.$nextTick(() => {
                this.scrollNearPageBottom()
                this.showCascadeModal = true
            })
        }

        this.handleOpenConnectorSidebarFromQuery()
        this.handleOpenChannelCreationFromQuery()
        this.handleOpenAddChannelBillingFromQuery()
    },
    destroyed() {},
}
</script>
<style lang="sass" scoped>
@import '@/vars.sass'
.connector-selected
    background-color: black
.right-th-margin
    text-align: center
.margin-right-block
    spadding-right: 10%
.section-head
    display: flex
    align-items: center
    gap: 9px

.section-title
    font-family: $font-family-base
    font-size: 21px
    font-weight: 900
    letter-spacing: -.025em
    color: $dark-new
    margin: 0
    line-height: 1.2

.btns-block
    max-width: 1016px
    display: flex
    flex-direction: column
    gap: 12px

.project-lock-scope
    position: relative
    z-index: 1
    isolation: isolate
    &--blocked
        min-height: min(520px, calc(100vh - 140px))
    &__content
        min-width: 0
    &--blocked &__content
        pointer-events: none
        user-select: none
    &__blur
        position: absolute
        top: -10px
        right: -10px
        bottom: -10px
        left: -10px
        z-index: 1
        pointer-events: none
        background: rgba(248, 249, 255, .5)
        -webkit-backdrop-filter: blur(8px)
        backdrop-filter: blur(8px)

@media (max-width: 720px)
    .project-lock-scope--blocked
        min-height: min(460px, calc(100vh - 96px))
.navigation
    cursor: pointer
.gray-btn-outline
    border: 1px solid #0000001F

.v-application p
    margin: 0 !important

.table-block
    max-width: 1016px
button:focus
    outline: 0

.overlay
    position: absolute
    top: calc(-1 * (var(--app-topbar-extra-height, 0px) + var(--app-notification-height, 0px)))
    right: auto
    bottom: 0
    left: 50%
    width: 100vw
    height: auto
    margin-left: -50vw
    background-position: center top
    background-size: cover
    z-index: 0
    pointer-events: none

.project-page-content
    position: relative
    overflow: visible
    margin-top: 0

.project-hero
    position: relative
    z-index: 1
    padding-top: 24px
    padding-bottom: 24px
    overflow: visible
    > *:not(.overlay)
        position: relative
        z-index: 1
.project-title
    color: white
    position: relative
    z-index: 1
    font-size: 24px
    max-width: 900px
    white-space: nowrap
    font-weight: 700
    overflow: hidden
    text-overflow: ellipsis
.project-title-wrapper
    display: flex
    align-items: center
    margin-top: 0

::v-deep.sightseeing-tour
    top: 50% !important
    left: 50% !important
    transform: translate(-50%, -50%) !important

::v-deep .sightseeing-tour:not(.kinescope-player-container_big)
    height: min-content

@media (min-width: 2000px)
    ::v-deep.sightseeing-tour
        transform: translate(-50%, -50%) scale(1.3) !important
@media (max-width: 1650px)
    ::v-deep.sightseeing-tour
        transform: translate(-50%, -50%) scale(0.8) !important
</style>
